module.exports = __webpack_public_path__ + "cancellara-dist/img/jointly.d07cae97.png";